module.exports = __webpack_public_path__ + "img/motor_no58.da698f38.jpg";